var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.81818,14.26757a3.82427,3.82427,0,0,1-.45454,7.58957,3.726,3.726,0,0,1-3.63637-3.80952,3.98144,3.98144,0,0,1,.14031-1.05158L8.774,14.26014a3.60737,3.60737,0,0,1-3.13762,1.88272A3.726,3.726,0,0,1,2,12.33333,3.726,3.726,0,0,1,5.63636,8.52381a3.59263,3.59263,0,0,1,3.024,1.69312l6.27213-3.2854a3.9673,3.9673,0,0,1-.20524-1.26486,3.6403,3.6403,0,1,1,7.27273,0,3.75357,3.75357,0,0,1-3.18182,3.78ZM15.226,16.12081a3.63429,3.63429,0,0,1,2.68307-1.85324V9.44672a3.61866,3.61866,0,0,1-2.56947-1.66365L9.06749,11.06848a4.00493,4.00493,0,0,1,.06493,2.31643Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareConnection);
export default __webpack_public_path__ + "static/media/share_connection.2079cd4127ac9f2d9af54d0d56ccf61c.svg";
export { ForwardRef as ReactComponent };